"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BreadCrumb = require("../../components/BreadCrumb/BreadCrumb");

var _BreadCrumb2 = _interopRequireDefault(_BreadCrumb);

var _PanelContainer = require("../PanelContainer/PanelContainer");

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _Wizard = require("./Wizard.css");

var _Wizard2 = _interopRequireDefault(_Wizard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//     


var Wizard = function (_Component) {
	_inherits(Wizard, _Component);

	function Wizard(props) {
		_classCallCheck(this, Wizard);

		var _this = _possibleConstructorReturn(this, (Wizard.__proto__ || Object.getPrototypeOf(Wizard)).call(this, props));

		_this.state = {
			currentStepIN: CONSTANTS.PAS0_SELECCIO_BD,
			currentStep: CONSTANTS.PAS5_PINTARDADES,
			steps: CONSTANTS.STEPS,
			valuegrid: 12,
			isNewVisor: true,
			visible: true
		};

		_this.childPanelContainer = _react2.default.createRef();

		return _this;
	}
	//PAS5_PINTARDADES


	_createClass(Wizard, [{
		key: "componentDidMount",
		value: function componentDidMount() {

			var cachedStep = this.props.currentId ? 0 : localStorage.getItem(CONSTANTS.CURRENT_STEP);

			if (this.props.currentId) {

				this.setState({ isNewVisor: false });
				this.updateSteps(CONSTANTS.PAS5_PINTARDADES);
			} else {

				if (document.location.href && document.location.href.indexOf("localhost2") != -1) {
					this.updateSteps(cachedStep ? Number(cachedStep) : this.state.currentStep);
					//this.updateSteps(0);
				} else {
					localStorage.clear();
					this.updateCurrentStep(0, true);
				}
				//this.updateSteps(0);
			}
		}
	}, {
		key: "updateCurrentStep",
		value: function updateCurrentStep(stepValue) {
			var doReset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


			this.updateSteps(stepValue);
			if (doReset) this.childPanelContainer.current.resetStateJsonConfig();
		}
	}, {
		key: "updateSteps",
		value: function updateSteps(currentStep) {
			var _this2 = this;

			var newSteps = [];
			var newVisible = false;
			var newValuegrid = 14;

			for (var i = 0; i < this.state.steps.length; i++) {
				if (i < currentStep) {
					newSteps[i] = _extends({}, this.state.steps[i], { active: false, completed: true, link: true, onClick: this.updateCurrentStep.bind(this, this.state.steps[i].key) });
				} else if (i === currentStep) {
					newSteps[i] = _extends({}, this.state.steps[i], { active: true, completed: false, link: false });
				} else {
					newSteps[i] = _extends({}, this.state.steps[i], { active: false, completed: false, link: false });
				}
			}

			//console.info(currentStep);
			if (currentStep === CONSTANTS.PAS5_PINTARDADES) {
				newVisible = false;
				newValuegrid = 16;
			} else {
				newVisible = true;
				newValuegrid = 12;
			}

			this.setState({ steps: newSteps, currentStep: currentStep, visible: newVisible, valuegrid: newValuegrid }, function () {
				return localStorage.setItem(CONSTANTS.CURRENT_STEP, _this2.state.currentStep);
			});
		}
	}, {
		key: "render",
		value: function render() {

			var currentStep = this.state.currentStep;
			if (currentStep === CONSTANTS.PAS5_PINTARDADES) {

				return _react2.default.createElement(
					_semanticUiReact.Grid,
					{ className: _Wizard2.default.wizardContainer, celled: true },
					_react2.default.createElement(
						_semanticUiReact.Grid.Row,
						null,
						_react2.default.createElement(_PanelContainer2.default, { ref: this.childPanelContainer,
							organization: this.props.organization,
							currentId: this.props.currentId,
							currentStep: this.state.currentStep,
							isNewVisor: this.state.isNewVisor,
							updateCurrentStep: this.updateCurrentStep.bind(this) })
					)
				);
			} else {

				return _react2.default.createElement(
					_semanticUiReact.Grid,
					{ celled: true, className: _Wizard2.default.wizardContainer },
					_react2.default.createElement(
						_semanticUiReact.Grid.Row,
						null,
						_react2.default.createElement(
							_semanticUiReact.Grid.Column,
							{ width: 4 },
							_react2.default.createElement(_BreadCrumb2.default, { steps: this.state.steps })
						),
						_react2.default.createElement(
							_semanticUiReact.Grid.Column,
							{ width: 12 },
							_react2.default.createElement(_PanelContainer2.default, { ref: this.childPanelContainer, organization: this.props.organization, currentId: this.props.currentId, currentStep: this.state.currentStep, updateCurrentStep: this.updateCurrentStep.bind(this) })
						)
					)
				);
			}
		}
	}]);

	return Wizard;
}(_react.Component);

exports.default = Wizard;


Wizard.propTypes = {
	currentId: _propTypes2.default.string,
	organization: _propTypes2.default.string
};
